<template>
  <div class="content-wrapper view-aptlist-manage p-0">
    <div class="content">
      <div class="card">
        <div class="card-body">
          <h4><i class="fas fa-boxes"></i> ตั้งค่าหมวดหมู่สินค้า</h4>

          <div class="row mx-1 my-3">
            <b-form-input
              type="search"
              class="col"
              autofocus
              v-model="filter"
              placeholder="ค้นหาหมวดหมู่สินค้า จากรหัส หรือชื่อหมวดหมู่"
            ></b-form-input>
            <b-button
              class="col-5 col-sm-4 col-md-3 ml-3"
              variant="primary"
              @click="openCategoryItemModal()"
            >
              <i class="fas fa-plus"></i> เพิ่มรายการ
            </b-button>
          </div>

          <b-table
            id="categoryManageTable"
            ref="categoryManageTable"
            hover
            small
            sort-icon-left
            head-variant="light"
            :items="getCategoryList"
            :fields="fields"
            :filter="filter"
            :filter-function="filterCategories"
            sort-by="creationDt"
            :sort-desc="true"
            :responsive="true"
          >
            <template v-slot:cell(index)="row">{{ row.index + 1 }}.</template>
            <template v-slot:cell(creationDt)="row">{{
              formatDate(row.item.creationDt)
            }}</template>

            <template v-slot:cell(buttons)="row">
              <ActionButtonGroup
                :item="row.item"
                :show-info="false"
                edit-tooltip="แก้ไขหมวดหมู่สินค้า"
                delete-tooltip="ลบหมวดหมู่สินค้า"
                @edit="editCategory"
                @delete="deleteCategory"
                :disabled-edit="row.item.categoryStatus !== 'ACTIVE'"
                :disabled-delete="row.item.categoryStatus !== 'ACTIVE'"
              />
            </template>
          </b-table>
        </div>
      </div>
      <CategoryItem ref="categoryItemModal"></CategoryItem>
      <Dialog ref="Dialog"></Dialog>
      <Loading v-if="isLoading"></Loading>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import CategoryItem from "../../components/modal/ProductAndStock/CategoryItem.vue";
import Dialog from "../../components/modal/Dialog.vue";
import Loading from "@/components/Loading";
import ActionButtonGroup from "@/components/table/stock/button/ActionButtons.vue";

export default {
  name: "CategoryMaster",
  components: {
    CategoryItem,
    Dialog,
    Loading,
    ActionButtonGroup,
  },
  data() {
    return {
      isLoading: false,
      fields: [
        {
          key: "index",
          label: "",
          thStyle: { width: "6%" },
          tdStyle: { width: "6%" },
        },
        {
          key: "categoryCode",
          label: "รหัส",
          sortable: true,
          thStyle: { width: "12%" },
          tdStyle: { width: "12%" },
        },
        {
          key: "categoryNameTh",
          label: "ชื่อหมวดหมู่",
          sortable: true,
          thStyle: { width: "30%" },
          tdStyle: { width: "30%" },
        },
        {
          key: "categoryNameEn",
          label: "ชื่อหมวดหมู่ (Eng)",
          sortable: true,
          thStyle: { width: "29%" },
          tdStyle: { width: "29%" },
        },
        {
          key: "creationDt",
          label: "วันที่สร้าง",
          sortable: true,
          thStyle: { width: "14%" },
          tdStyle: { width: "14%" },
        },
        {
          key: "buttons",
          label: "",
          class: "text-center",
          thStyle: { width: "9%" },
          tdStyle: { width: "9%" },
        },
      ],
      filter: "",
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      getCategoryList: "moduleCategoryMaster/getCategoryList",
    }),
  },
  methods: {
    ...mapActions({
      fetchCategoryList: "moduleCategoryMaster/fetchCategoryList",
    }),
    async init() {
      this.isLoading = true;
      try {
        await this.fetchCategoryList({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
        });
      } catch (err) {
        this.showDialogToast("danger", "โหลดหมวดหมู่สินค้าไม่สำเร็จ");
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    formatDate(date) {
      if (date) {
        return moment(date).locale("th").format("D MMM YY");
      } else {
        return "";
      }
    },
    openCategoryItemModal(category = null) {
      this.$refs.categoryItemModal.show(category);
    },
    editCategory(category) {
      this.openCategoryItemModal(category);
    },
    deleteCategory(eventData) {
      this.$refs.Dialog.showAlertConfirm(
        "ลบหมวดหมู่สินค้านี้ ?",
        "คุณต้องการลบหมวดหมู่สินค้านี้ใช่หรือไม่"
      ).then(result => {
        if (!result.value) return;
        this.isLoading = true;
        this.$store
          .dispatch("moduleCategoryMaster/deleteCategoryItem", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            id: eventData.categoryId,
          })
          .then(res => {
            if (res.status == 200) {
              this.init();
              this.showDialogToast("success", "ลบรายการหมวดหมู่สินค้าสำเร็จ");
            }
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;

            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "ลบรายการหมวดหมู่สินค้าไม่สำเร็จ กรุณาลองใหม่";

            this.$parent.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    showDialogToast(variant, textDetail) {
      this.$refs.Dialog.showToast(variant, textDetail);
    },
    filterCategories(row, filter) {
      if (!filter || (typeof filter === "string" && !filter.trim())) {
        return true;
      }
      const s = String(filter).toLowerCase();
      const code = (row.categoryCode || "").toString().toLowerCase();
      const nameTh = (row.categoryNameTh || "").toString().toLowerCase();
      const nameEn = (row.categoryNameEn || "").toString().toLowerCase();
      return code.includes(s) || nameTh.includes(s) || nameEn.includes(s);
    },
  },
};
</script>

<style scoped>
::v-deep #categoryManageTable thead tr th,
::v-deep #categoryManageTable tbody tr td {
  vertical-align: middle !important;
}

::v-deep #categoryManageTable td {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}

::v-deep #categoryManageTable th {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}
</style>
